import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";
import { ReportCommentRequesBody, ReportCommentResponse } from "../../api/comment_report";

export type TApiPutReportCommentResult = {
  result?: ReportCommentResponse;
};

export const putReportBoardComment = async (
    body: ReportCommentRequesBody
): Promise<TApiResult & TApiPutReportCommentResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  return await client()
    .board_comment.report.put({
      body,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "putReportBoardComment");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
